import { render, staticRenderFns } from "./doubleBarChart.vue?vue&type=template&id=13972715&scoped=true"
import script from "./doubleBarChart.vue?vue&type=script&lang=js"
export * from "./doubleBarChart.vue?vue&type=script&lang=js"
import style0 from "./doubleBarChart.vue?vue&type=style&index=0&id=13972715&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13972715",
  null
  
)

export default component.exports